import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { string, bool, func } from 'prop-types';
import { Row, Col, Icon, Tooltip } from 'antd';
import { constants } from '../../devUtils';
import Container from '../../components/Container';
import endPoints from '../../config/endPoints';

const ManipalCignaLandingHeaderIcons = (otherParams) => {
  const {
    isLoggedIn,
    handleShowLogin,
    handleLogout,
    cart = {},
  } = otherParams;
  if (isLoggedIn) {
    return (
      <Fragment>
        <Link to={constants.GIFT_CARD_CART} className="cart" >
          <Tooltip placement="top" title="My Cart">
            <Icon type="shopping-cart" className="icon-raise" />
            {(cart && cart.items_count && cart.items_count !== 0) ?
              <span className="badge">{cart.items_count}</span> : null}
          </Tooltip>
        </Link>
        <Link to={constants.LINK_MY_PROFILE} >
          <Tooltip placement="top" title="My Account">
            <Icon type="user" className="icon-raise" />
          </Tooltip>
        </Link>
        <Tooltip placement="top" title="Logout">
          <Icon type="logout" className="icon-raise" onClick={() => handleLogout()} />
        </Tooltip>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <Tooltip placement="top" title="Login">
        <Icon type="logout" className="icon-raise" onClick={() => handleShowLogin()} />
      </Tooltip>
    </Fragment>
  );
};

const ManipalCignaLandingHeader = (otherParams) => {
  const {
    logo,
    brand_logo,
    pathname,
  } = otherParams;
  return (
    <section className="cilent-fixed-nav">
      <div className="client-secoundary-header-bg">
        <Container>
          <Row align="middle" type="flex" className="client-header">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="portal_name">
                <a href={constants.LINK_CLIENT_MANIPAL} >
                  <img src={brand_logo} alt="no_image" className="brand-logo" />
                </a>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} className="text-right">
              <div className="portal_name">
                <a href={constants.MANIPAL_CIGNA_MAIN} >
                  <img src={logo} alt="no_image" className="cilent-logo" />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Row align="middle" type="flex" className="client-header-bg">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right">
          <Container>
            { constants.LINK_MANIPAL_ABOUTUS === pathname ? (
              <a href={constants.LINK_CLIENT_MANIPAL} >
                <Tooltip placement="top" title="Catalogue">
                  <img src={endPoints.MANIPAL_HOME_LOGO.URL} alt={endPoints.MANIPAL_HOME_LOGO.ALT} className="manipal-home-logo" />
                </Tooltip>
              </a>
            ) : (
              <Link to={constants.LINK_MANIPAL_ABOUTUS} >
                <Tooltip placement="top" title="Home">
                  <Icon type="home" className="icon-raise" />
                </Tooltip>
              </Link>
            ) }
            { ManipalCignaLandingHeaderIcons(otherParams)}
          </Container>
        </Col>
      </Row>
    </section>
  );
};

const ClientLandingHeader = ({ portal_name, isOnlyMerchandise, logo, ...otherParams }) => (
  <header>
    {isOnlyMerchandise ?
      ManipalCignaLandingHeader({ logo, ...otherParams })
      :
      <Container>
        <Row align="middle" type="flex" gutter={4} className="client-header">
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mobile-center">
            <Link to={constants.LINK_GIFTCARD_LIST}>
              <img src={portal_name} alt="no_image" style={{ height: '62px', width: 'auto' }} />
            </Link>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right mobile-center">
            {/* <div className="portal_name">{portal_name}</div> */}
            <div className="portal_name">
              <img src={logo} alt="no_image" style={{ height: '62px', width: 'auto' }} />
            </div>
          </Col>
        </Row>
      </Container>
    }
  </header>
);

ClientLandingHeader.defaultProps = {
  isOnlyMerchandise: false,
  portal_name: '',
  top_banner: '',
  brand_logo: '',
  pathname: '',
  isLoggedIn: false,
  handleShowLogin: () => {},
  handleLogout: () => {},
};

ClientLandingHeader.propTypes = {
  logo: string.isRequired,
  portal_name: string,
  top_banner: string,
  pathname: string,
  brand_logo: string,
  isOnlyMerchandise: bool,
  isLoggedIn: bool,
  handleShowLogin: func,
  handleLogout: func,
};

export { ClientLandingHeader };



// WEBPACK FOOTER //
// client/containers/HeaderContainer/clientLandingHeader.js